<template>
  <div>
    <form
      id="eGateRegistration"
      class="register-form"
      @submit.prevent="eGateRegistration"
    >
      <input id="service_id" type="hidden" name="service_id" :value="id" />
      <div class="form-group">
        <div class="partition-title">
          {{ $t('account.label.register_egate') }}
        </div>
        <label class="label_egate_info">{{
          $t('account.label.register_egate_info')
        }}</label>
      </div>
      <div class="form-group">
        <div class="egate-icon"></div>
      </div>
      <div class="form-group">
        <div class="form-group-egate">
          <button type="submit" class="btn btn-primary blue-fill-in">
            {{ $t('account.button.register_egate') }}
          </button>
        </div>
      </div>
    </form>
    <div class="info-msg-egate"></div>
    <!--form
      action="https://www.epaslaugos.lt/portal-test/external/services/authentication/v2/"
      method="post"
    >
      <input type="hidden" name="ticket" :value="ticket" />
      <button ref="egates" type="submit" style="display:none;">Submit</button>
    </form>-->
  </div>
</template>

<script>
export default {
  title: '',
  name: 'EGateForm',
  props: {
    id: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      ticket: '',
    }
  },
  computed: {
    model() {
      return this.$store.getters['dataAuth']
    },
  },
  methods: {
    eGateRegistration: function () {
      this.model.pending = true
      this.errors = []
      const payload = { service_id: this.id }
      axios
        .post('/auth/client/e-gate', payload)
        .then((response) => {
          this.model.pending = false
          if (response.data.status === 'success' && response.data.portal_url) {
            this.ticket = response.data.ticket
            if (this.ticket) {
              this.$nextTick(() => {
                window.location.href = response.data.portal_url
              })
            }
          }
        })
        .catch(() => {
          this.model.pending = false
        })
    },
  },
}
</script>
